module.exports = __webpack_public_path__ + "static/media/logowhite.1109ec9c.png";